// Animated wave background for the main navbar.
// Replicates the iOS app's UIKit WaveView: three overlapping sine waves,
// each filled downward from its curve to the bottom of the canvas.
document.addEventListener("DOMContentLoaded", function () {
    const canvas = document.getElementById("navbarWaveCanvas");
    if (!canvas) return; // navbar is not rendered in app mode

    const header = canvas.parentElement;
    const ctx = canvas.getContext("2d");

    const waves = [
        { height: 10, speed: 0.004,  frequency: 1.5, color: "rgba(50, 120, 150, 0.6)", offset: 0 },
        { height: 15, speed: -0.003, frequency: 1.2, color: "rgba(40, 110, 140, 0.4)", offset: 0 },
        { height: 13, speed: 0.002,  frequency: 1.0, color: "rgba(30, 100, 130, 0.3)", offset: 0 },
    ];

    function resize() {
        canvas.width = header.offsetWidth;
        canvas.height = header.offsetHeight;
    }

    // The header height changes when the mobile menu collapses/expands,
    // so observe the element instead of only listening to window resizes.
    if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(resize).observe(header);
    } else {
        window.addEventListener("resize", resize);
    }
    resize();

    function draw() {
        const width = canvas.width;
        const height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        const midY = height * 0.7;

        for (const wave of waves) {
            ctx.beginPath();
            ctx.moveTo(0, height);
            for (let x = 0; x <= width; x++) {
                const y = wave.height * Math.sin((x / width) * Math.PI * 2 * wave.frequency + wave.offset) + midY;
                ctx.lineTo(x, y);
            }
            ctx.lineTo(width, height);
            ctx.closePath();
            ctx.fillStyle = wave.color;
            ctx.fill();
            wave.offset += wave.speed;
        }

        requestAnimationFrame(draw);
    }

    requestAnimationFrame(draw);
});
